import bugsnag from 'bugsnag-js';

window.bugsnagClient = bugsnag({
    apiKey: document.querySelector('meta[name=bugsnag-api-key]').content,
    releaseStage: document.querySelector('meta[name=environment]').content,
    notifyReleaseStages: ['production', 'uat']
});